import { Methods, Response } from 'types/request.ts'
import { CreateComplaintCaseRequestBody, CreateComplaintCaseResponseBody } from '@boltenergy-be/shared'
import { getAxiosRequestConfigBoltBackend, newRequest } from 'utils/request.ts'
import { log } from 'utils/logging.ts'
import { Flow } from 'types/logging.ts'

export const postComplaintCase = async (body: CreateComplaintCaseRequestBody): Promise<Response<CreateComplaintCaseResponseBody>> => {
  try {
    const res = await newRequest<CreateComplaintCaseResponseBody>(
      getAxiosRequestConfigBoltBackend(Methods.POST, '/resources/cases/complaints', body)
    )

    if (!res.success) {
      log({
        error: res?.message || 'unknown error with postComplaint',
        identifier: `[${Flow.CASES}:complaint${res?.errorCode ? `:${res.errorCode}` : ''}]`,
        errorCode: res?.errorCode
      })
    }

    return res
  } catch (error) {
    log({
      error: error instanceof Error ? error : 'Unknown error in postComplaint',
      identifier: `[${Flow.CASES}:CATCH:complaint]`
    })
    return { success: false }
  }
}
